import { Phone } from "lucide-react";
import { COMPANY } from "../data/site";

export default function MobileStickyBar() {
  return (
    <div
      data-testid="mobile-sticky-bar"
      className="lg:hidden fixed bottom-0 left-0 right-0 z-40 bg-stone-900 text-white border-t border-red-600"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <div className="grid grid-cols-2">
        <a
          href={COMPANY.phoneTel}
          data-testid="mobile-bar-call"
          className="flex items-center justify-center gap-2 py-4 text-sm font-bold border-r border-stone-700"
        >
          <Phone size={16} /> Call Now
        </a>
        <a
          href="/contact"
          data-testid="mobile-bar-estimate"
          className="flex items-center justify-center gap-2 py-4 text-sm font-bold bg-red-600"
        >
          Free Estimate →
        </a>
      </div>
    </div>
  );
}
